/**
 * 用户信息辅助函数
 * 用于从 localStorage 获取用户信息
 */

/**
 * 获取当前登录用户的手机号
 * @returns {String|null} 手机号
 */
export const getUserPhone = () => {
  try {
    // 从 localStorage 读取 phone
    const phone = uni.getStorageSync('phone');
    return phone || null;
  } catch (error) {
    console.error('[User Helper] 获取手机号失败:', error);
    return null;
  }
};

/**
 * 获取当前登录用户的 token
 * @returns {String|null} token
 */
export const getUserToken = () => {
  try {
    const token = uni.getStorageSync('v-token');
    return token || null;
  } catch (error) {
    console.error('[User Helper] 获取 token 失败:', error);
    return null;
  }
};

/**
 * 获取当前用户的完整信息（用于 Sentry）
 * @returns {Object} 用户信息对象
 */
export const getCurrentUserInfo = () => {
  const phone = getUserPhone();
  
  if (!phone) {
    return null;
  }
  
  return {
    id: phone,  // 使用手机号作为唯一标识
    phone: phone,
    username: phone,
  };
};

/**
 * 检查用户是否已登录
 * @returns {Boolean}
 */
export const isUserLoggedIn = () => {
  const token = getUserToken();
  const phone = getUserPhone();
  return !!(token && phone);
};

export default {
  getUserPhone,
  getUserToken,
  getCurrentUserInfo,
  isUserLoggedIn,
};

